import React from 'react';
import StudentResponsesContainer from 'legacy/src/components/scoring/StudentResponsesContainer';
import './StudentResponses.scss';

const StudentResponses = (props) => {
  const { assignment, router, location } = props;

  const { questions } = assignment || {};
  const firstQuestion = questions && questions.length && questions[0];

  if (firstQuestion && !location.pathname.match('questions')) {
    router.replace(`${location.pathname}/questions/${firstQuestion.id}`);
  }

  return (
    <StudentResponsesContainer {...props} showHeader={false} canSave={false} />
  );
};

export default StudentResponses;
